module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "d_question",
    staticClass: "d-question",
    on: {
      "mouseenter": function($event) {
        _vm.isHovered = true
      },
      "mouseleave": function($event) {
        _vm.isHovered = false
      }
    }
  }, [_c('div', {
    ref: "d_popover",
    staticClass: "d-question__answer",
    class: {
      'd-question__answer--show': _vm.isHovered
    }
  }, [_vm._t("answer", function() {
    return [_c('p', [_vm._v("Her er svar på dine spørgsmål")])]
  })], 2), _vm._v(" "), _c('svg', {
    attrs: {
      "width": "16px",
      "height": "16px",
      "viewBox": "0 0 16 16"
    }
  }, [_c('g', {
    attrs: {
      "id": "Artboard-2",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group-2"
    }
  }, [_c('circle', {
    attrs: {
      "id": "Oval-10",
      "fill": "#a2a3a6",
      "cx": "8",
      "cy": "8",
      "r": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M7.354,9.657 L7.354,9.294 C7.354,7.732 9.059,7.292 9.059,6.148 C9.059,5.51 8.652,5.191 8.014,5.191 C7.343,5.191 6.826,5.609 6.826,6.445 L5.473,6.445 C5.473,4.729 6.573,3.948 8.102,3.948 C9.389,3.948 10.533,4.608 10.533,6.005 C10.533,7.666 8.663,8.183 8.663,9.437 L8.663,9.657 L7.354,9.657 Z M7.156,11.373 C7.156,10.878 7.464,10.559 8.003,10.559 C8.509,10.559 8.85,10.878 8.85,11.34 C8.85,11.813 8.509,12.143 8.003,12.143 C7.464,12.143 7.156,11.813 7.156,11.373 Z",
      "id": "?",
      "fill": "#FFFFFF"
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3f1dafca!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/DQuestionMark.vue
// module id = 1542
// module chunks = 1